"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MOVE = exports.MINIMIZED = exports.MARKETPLACE = exports.MANAGE = exports.MAIL_LIST = exports.LOCK = exports.LOCATION = exports.LOAN_TRACKER = exports.LINK = exports.LAWYER = exports.LAST_PAGE = exports.JUSTIFY = exports.ITALIC = exports.HOT_LEADS = exports.HOME = exports.HISTORY = exports.HIGHLIGHT = exports.HIDE = exports.HEADING_6 = exports.HEADING_5 = exports.HEADING_4 = exports.HEADING_3 = exports.HEADING_2 = exports.HEADING_1 = exports.GO = exports.GO_TO = exports.FORM = exports.FONT_COLOR = exports.FIT_TO_SCREEN = exports.FIRST_PAGE = exports.FILTER = exports.FAVORITE = exports.EMAIL = exports.EDIT = exports.DROPDOWN = exports.DROPDOWN_OUTLINE = exports.DOWNLOAD = exports.DOCUMENTS = exports.DEVELOPER = exports.DETAILS = exports.DESCRIPTION = exports.CUSTOMIZE = exports.CREDIT_CHECK = exports.COPY = exports.CONTACTS = exports.COLOR_PICKER = exports.COLLAPSE = exports.COLD_LEADS = exports.CODE_BLOCK_2 = exports.CODE_BLOCK_1 = exports.CLOSE = exports.CHAT = exports.CANCEL_INVITATION = exports.CAMERA = exports.CALL = exports.CALENDAR = exports.BUSINESS_UNIT = exports.BOOKING = exports.BOOKING_SETUP = exports.BOLD = exports.BLOCK_CODE_CURLY = exports.BANKER = exports.ATTACH = exports.ALIGN_RIGHT = exports.ALIGN_MIDDLE = exports.ALIGN_LEFT = exports.AGENT = exports.ADMIN = exports.ADD = exports.ADD_USER = exports.ADD_LEAD = exports.ADD_COLUMNS = exports.ADD_CIRCLE = exports.ACTIVITY_LOG_MILESTONE = exports.ACTION_MENU = exports.SETTINGS = exports.SEARCH = exports.REPORT = exports.PROFILE = exports.OPPORTUNITY = exports.NOTIFICATIONS = exports.MENU_SQUARE = exports.MENU_HAMBURGER = exports.LOGOUT = exports.LOGIN = exports.LEADS = exports.INFO = exports.HELP = exports.DELETE = exports.CLOSE_CANCEL_2 = exports.CLOSE_CANCEL_1 = exports.CHEVRON_RIGHT = exports.CHEVRON_RIGHT_S = exports.CHEVRON_LEFT = exports.CHEVRON_LEFT_S = exports.CAMPAIGN = exports.UNORDERED_LIST_UL_BULLET_POINT = exports.ORDERED_LIST_OL = exports.BLOCK_QUOTE = exports.CALCULATOR = void 0;
exports.ICON_NAMES = exports.ZOOM_OUT = exports.ZOOM_IN = exports.WARM_LEADS = exports.VIEW = exports.VIEW_SALES_CHART = exports.UPLOAD = exports.UPGRADE = exports.UPDATE_LEAD_AGE = exports.UNIT_SETUP = exports.UNDO = exports.UNDERLINE = exports.TIME = exports.TICK = exports.TAGS = exports.SYMBOL = exports.STRIKETHROUGH = exports.STATUS = exports.STAFF = exports.SPA = exports.SORT = exports.SMS = exports.SHOWROOM = exports.SHARE = exports.SEND = exports.SCHEDULE = exports.SAVE = exports.ROTATE = exports.ROTATE_ANTI_CLOCKWISE = exports.REVEAL = exports.REMOVE = exports.REMARK = exports.RELOAD = exports.REDO = exports.REASSIGN = exports.RE_INVITE = exports.PROJECT = exports.PRINT = exports.PREVIEW = exports.POST_SALES = exports.PERFORMANCE = exports.PAYMENT = exports.NUDGE = void 0;
var CALCULATOR = 'calculator';
exports.CALCULATOR = CALCULATOR;
var BLOCK_QUOTE = 'block_quote';
exports.BLOCK_QUOTE = BLOCK_QUOTE;
var ORDERED_LIST_OL = 'ordered_list_ol';
exports.ORDERED_LIST_OL = ORDERED_LIST_OL;
var UNORDERED_LIST_UL_BULLET_POINT = 'unordered_list_ul_bullet_point';
exports.UNORDERED_LIST_UL_BULLET_POINT = UNORDERED_LIST_UL_BULLET_POINT;
var CAMPAIGN = 'campaign';
exports.CAMPAIGN = CAMPAIGN;
var CHEVRON_LEFT_S = 'chevron_left_s';
exports.CHEVRON_LEFT_S = CHEVRON_LEFT_S;
var CHEVRON_LEFT = 'chevron_left';
exports.CHEVRON_LEFT = CHEVRON_LEFT;
var CHEVRON_RIGHT_S = 'chevron_right_s';
exports.CHEVRON_RIGHT_S = CHEVRON_RIGHT_S;
var CHEVRON_RIGHT = 'chevron_right';
exports.CHEVRON_RIGHT = CHEVRON_RIGHT;
var CLOSE_CANCEL_1 = 'close_cancel_1';
exports.CLOSE_CANCEL_1 = CLOSE_CANCEL_1;
var CLOSE_CANCEL_2 = 'close_cancel_2';
exports.CLOSE_CANCEL_2 = CLOSE_CANCEL_2;
var DELETE = 'delete';
exports.DELETE = DELETE;
var HELP = 'help';
exports.HELP = HELP;
var INFO = 'info';
exports.INFO = INFO;
var LEADS = 'leads';
exports.LEADS = LEADS;
var LOGIN = 'login';
exports.LOGIN = LOGIN;
var LOGOUT = 'logout';
exports.LOGOUT = LOGOUT;
var MENU_HAMBURGER = 'menu_hamburger';
exports.MENU_HAMBURGER = MENU_HAMBURGER;
var MENU_SQUARE = 'menu_square';
exports.MENU_SQUARE = MENU_SQUARE;
var NOTIFICATIONS = 'notifications';
exports.NOTIFICATIONS = NOTIFICATIONS;
var OPPORTUNITY = 'opportunity';
exports.OPPORTUNITY = OPPORTUNITY;
var PROFILE = 'profile';
exports.PROFILE = PROFILE;
var REPORT = 'report';
exports.REPORT = REPORT;
var SEARCH = 'search';
exports.SEARCH = SEARCH;
var SETTINGS = 'settings';
exports.SETTINGS = SETTINGS;
var ACTION_MENU = 'action_menu';
exports.ACTION_MENU = ACTION_MENU;
var ACTIVITY_LOG_MILESTONE = 'activity_log_milestone';
exports.ACTIVITY_LOG_MILESTONE = ACTIVITY_LOG_MILESTONE;
var ADD_CIRCLE = 'add_circle';
exports.ADD_CIRCLE = ADD_CIRCLE;
var ADD_COLUMNS = 'add_columns';
exports.ADD_COLUMNS = ADD_COLUMNS;
var ADD_LEAD = 'add_lead';
exports.ADD_LEAD = ADD_LEAD;
var ADD_USER = 'add_user';
exports.ADD_USER = ADD_USER;
var ADD = 'add';
exports.ADD = ADD;
var ADMIN = 'admin';
exports.ADMIN = ADMIN;
var AGENT = 'agent';
exports.AGENT = AGENT;
var ALIGN_LEFT = 'align_left';
exports.ALIGN_LEFT = ALIGN_LEFT;
var ALIGN_MIDDLE = 'align_middle';
exports.ALIGN_MIDDLE = ALIGN_MIDDLE;
var ALIGN_RIGHT = 'align_right';
exports.ALIGN_RIGHT = ALIGN_RIGHT;
var ATTACH = 'attach';
exports.ATTACH = ATTACH;
var BANKER = 'banker';
exports.BANKER = BANKER;
var BLOCK_CODE_CURLY = 'block_code_curly';
exports.BLOCK_CODE_CURLY = BLOCK_CODE_CURLY;
var BOLD = 'bold';
exports.BOLD = BOLD;
var BOOKING_SETUP = 'booking_setup';
exports.BOOKING_SETUP = BOOKING_SETUP;
var BOOKING = 'booking';
exports.BOOKING = BOOKING;
var BUSINESS_UNIT = 'business_unit';
exports.BUSINESS_UNIT = BUSINESS_UNIT;
var CALENDAR = 'calendar';
exports.CALENDAR = CALENDAR;
var CALL = 'call';
exports.CALL = CALL;
var CAMERA = 'camera';
exports.CAMERA = CAMERA;
var CANCEL_INVITATION = 'cancel_invitation';
exports.CANCEL_INVITATION = CANCEL_INVITATION;
var CHAT = 'chat';
exports.CHAT = CHAT;
var CLOSE = 'close';
exports.CLOSE = CLOSE;
var CODE_BLOCK_1 = 'code_block_1';
exports.CODE_BLOCK_1 = CODE_BLOCK_1;
var CODE_BLOCK_2 = 'code_block_2';
exports.CODE_BLOCK_2 = CODE_BLOCK_2;
var COLD_LEADS = 'cold_leads';
exports.COLD_LEADS = COLD_LEADS;
var COLLAPSE = 'collapse';
exports.COLLAPSE = COLLAPSE;
var COLOR_PICKER = 'color_picker';
exports.COLOR_PICKER = COLOR_PICKER;
var CONTACTS = 'contacts';
exports.CONTACTS = CONTACTS;
var COPY = 'copy';
exports.COPY = COPY;
var CREDIT_CHECK = 'credit_check';
exports.CREDIT_CHECK = CREDIT_CHECK;
var CUSTOMIZE = 'customize';
exports.CUSTOMIZE = CUSTOMIZE;
var DESCRIPTION = 'description';
exports.DESCRIPTION = DESCRIPTION;
var DETAILS = 'details';
exports.DETAILS = DETAILS;
var DEVELOPER = 'developer';
exports.DEVELOPER = DEVELOPER;
var DOCUMENTS = 'documents';
exports.DOCUMENTS = DOCUMENTS;
var DOWNLOAD = 'download';
exports.DOWNLOAD = DOWNLOAD;
var DROPDOWN_OUTLINE = 'dropdown_outline';
exports.DROPDOWN_OUTLINE = DROPDOWN_OUTLINE;
var DROPDOWN = 'dropdown';
exports.DROPDOWN = DROPDOWN;
var EDIT = 'edit';
exports.EDIT = EDIT;
var EMAIL = 'email';
exports.EMAIL = EMAIL;
var FAVORITE = 'favorite';
exports.FAVORITE = FAVORITE;
var FILTER = 'filter';
exports.FILTER = FILTER;
var FIRST_PAGE = 'first_page';
exports.FIRST_PAGE = FIRST_PAGE;
var FIT_TO_SCREEN = 'fit_to_screen';
exports.FIT_TO_SCREEN = FIT_TO_SCREEN;
var FONT_COLOR = 'font_color';
exports.FONT_COLOR = FONT_COLOR;
var FORM = 'form';
exports.FORM = FORM;
var GO_TO = 'go_to';
exports.GO_TO = GO_TO;
var GO = 'go';
exports.GO = GO;
var HEADING_1 = 'heading_1';
exports.HEADING_1 = HEADING_1;
var HEADING_2 = 'heading_2';
exports.HEADING_2 = HEADING_2;
var HEADING_3 = 'heading_3';
exports.HEADING_3 = HEADING_3;
var HEADING_4 = 'heading_4';
exports.HEADING_4 = HEADING_4;
var HEADING_5 = 'heading_5';
exports.HEADING_5 = HEADING_5;
var HEADING_6 = 'heading_6';
exports.HEADING_6 = HEADING_6;
var HIDE = 'hide';
exports.HIDE = HIDE;
var HIGHLIGHT = 'highlight';
exports.HIGHLIGHT = HIGHLIGHT;
var HISTORY = 'history';
exports.HISTORY = HISTORY;
var HOME = 'home';
exports.HOME = HOME;
var HOT_LEADS = 'hot_leads';
exports.HOT_LEADS = HOT_LEADS;
var ITALIC = 'italic';
exports.ITALIC = ITALIC;
var JUSTIFY = 'justify';
exports.JUSTIFY = JUSTIFY;
var LAST_PAGE = 'last_page';
exports.LAST_PAGE = LAST_PAGE;
var LAWYER = 'lawyer';
exports.LAWYER = LAWYER;
var LINK = 'link';
exports.LINK = LINK;
var LOAN_TRACKER = 'loan_tracker';
exports.LOAN_TRACKER = LOAN_TRACKER;
var LOCATION = 'location';
exports.LOCATION = LOCATION;
var LOCK = 'lock';
exports.LOCK = LOCK;
var MAIL_LIST = 'mail_list';
exports.MAIL_LIST = MAIL_LIST;
var MANAGE = 'manage';
exports.MANAGE = MANAGE;
var MARKETPLACE = 'marketplace';
exports.MARKETPLACE = MARKETPLACE;
var MINIMIZED = 'minimized';
exports.MINIMIZED = MINIMIZED;
var MOVE = 'move';
exports.MOVE = MOVE;
var NUDGE = 'nudge';
exports.NUDGE = NUDGE;
var PAYMENT = 'payment';
exports.PAYMENT = PAYMENT;
var PERFORMANCE = 'performance';
exports.PERFORMANCE = PERFORMANCE;
var POST_SALES = 'post_sales';
exports.POST_SALES = POST_SALES;
var PREVIEW = 'preview';
exports.PREVIEW = PREVIEW;
var PRINT = 'print';
exports.PRINT = PRINT;
var PROJECT = 'project';
exports.PROJECT = PROJECT;
var RE_INVITE = 're_Invite';
exports.RE_INVITE = RE_INVITE;
var REASSIGN = 'reassign';
exports.REASSIGN = REASSIGN;
var REDO = 'redo';
exports.REDO = REDO;
var RELOAD = 'reload';
exports.RELOAD = RELOAD;
var REMARK = 'remark';
exports.REMARK = REMARK;
var REMOVE = 'remove';
exports.REMOVE = REMOVE;
var REVEAL = 'reveal';
exports.REVEAL = REVEAL;
var ROTATE_ANTI_CLOCKWISE = 'rotate_anti_clockwise';
exports.ROTATE_ANTI_CLOCKWISE = ROTATE_ANTI_CLOCKWISE;
var ROTATE = 'rotate';
exports.ROTATE = ROTATE;
var SAVE = 'save';
exports.SAVE = SAVE;
var SCHEDULE = 'schedule';
exports.SCHEDULE = SCHEDULE;
var SEND = 'send';
exports.SEND = SEND;
var SHARE = 'share';
exports.SHARE = SHARE;
var SHOWROOM = 'showroom';
exports.SHOWROOM = SHOWROOM;
var SMS = 'sms';
exports.SMS = SMS;
var SORT = 'sort';
exports.SORT = SORT;
var SPA = 'spa';
exports.SPA = SPA;
var STAFF = 'staff';
exports.STAFF = STAFF;
var STATUS = 'status';
exports.STATUS = STATUS;
var STRIKETHROUGH = 'strikethrough';
exports.STRIKETHROUGH = STRIKETHROUGH;
var SYMBOL = 'symbol';
exports.SYMBOL = SYMBOL;
var TAGS = 'tags';
exports.TAGS = TAGS;
var TICK = 'tick';
exports.TICK = TICK;
var TIME = 'time';
exports.TIME = TIME;
var UNDERLINE = 'underline';
exports.UNDERLINE = UNDERLINE;
var UNDO = 'undo';
exports.UNDO = UNDO;
var UNIT_SETUP = 'unit_setup';
exports.UNIT_SETUP = UNIT_SETUP;
var UPDATE_LEAD_AGE = 'update_lead_age';
exports.UPDATE_LEAD_AGE = UPDATE_LEAD_AGE;
var UPGRADE = 'upgrade';
exports.UPGRADE = UPGRADE;
var UPLOAD = 'upload';
exports.UPLOAD = UPLOAD;
var VIEW_SALES_CHART = 'view_sales_chart';
exports.VIEW_SALES_CHART = VIEW_SALES_CHART;
var VIEW = 'view';
exports.VIEW = VIEW;
var WARM_LEADS = 'warm_leads';
exports.WARM_LEADS = WARM_LEADS;
var ZOOM_IN = 'zoom_in';
exports.ZOOM_IN = ZOOM_IN;
var ZOOM_OUT = 'zoom_out';
exports.ZOOM_OUT = ZOOM_OUT;
var ICON_NAMES = [CALCULATOR, BLOCK_QUOTE, ORDERED_LIST_OL, UNORDERED_LIST_UL_BULLET_POINT, CAMPAIGN, CHEVRON_LEFT_S, CHEVRON_LEFT, CHEVRON_RIGHT_S, CHEVRON_RIGHT, CLOSE_CANCEL_1, CLOSE_CANCEL_2, DELETE, HELP, INFO, LEADS, LOGIN, LOGOUT, MENU_HAMBURGER, MENU_SQUARE, NOTIFICATIONS, OPPORTUNITY, PROFILE, REPORT, SEARCH, SETTINGS, ACTION_MENU, ACTIVITY_LOG_MILESTONE, ADD_CIRCLE, ADD_COLUMNS, ADD_LEAD, ADD_USER, ADD, ADMIN, AGENT, ALIGN_LEFT, ALIGN_MIDDLE, ALIGN_RIGHT, ATTACH, BANKER, BLOCK_CODE_CURLY, BOLD, BOOKING_SETUP, BOOKING, BUSINESS_UNIT, CALENDAR, CALL, CAMERA, CANCEL_INVITATION, CHAT, CLOSE, CODE_BLOCK_1, CODE_BLOCK_2, COLD_LEADS, COLLAPSE, COLOR_PICKER, CONTACTS, COPY, CREDIT_CHECK, CUSTOMIZE, DESCRIPTION, DETAILS, DEVELOPER, DOCUMENTS, DOWNLOAD, DROPDOWN_OUTLINE, DROPDOWN, EDIT, EMAIL, FAVORITE, FILTER, FIRST_PAGE, FIT_TO_SCREEN, FONT_COLOR, FORM, GO_TO, GO, HEADING_1, HEADING_2, HEADING_3, HEADING_4, HEADING_5, HEADING_6, HIDE, HIGHLIGHT, HISTORY, HOME, HOT_LEADS, ITALIC, JUSTIFY, LAST_PAGE, LAWYER, LINK, LOAN_TRACKER, LOCATION, LOCK, MAIL_LIST, MANAGE, MARKETPLACE, MINIMIZED, MOVE, NUDGE, PAYMENT, PERFORMANCE, POST_SALES, PREVIEW, PRINT, PROJECT, RE_INVITE, REASSIGN, REDO, RELOAD, REMARK, REMOVE, REVEAL, ROTATE_ANTI_CLOCKWISE, ROTATE, SAVE, SCHEDULE, SEND, SHARE, SHOWROOM, SMS, SORT, SPA, STAFF, STATUS, STRIKETHROUGH, SYMBOL, TAGS, TICK, TIME, UNDERLINE, UNDO, UNIT_SETUP, UPDATE_LEAD_AGE, UPGRADE, UPLOAD, VIEW_SALES_CHART, VIEW, WARM_LEADS, ZOOM_IN, ZOOM_OUT]; // v1.9
// Last generated at Thu, 01 Aug 2019 10:32:04 GMT

exports.ICON_NAMES = ICON_NAMES;